<script setup lang="ts"></script>

<template>
  <div class="offers-outer">Axe Offers</div>
</template>

<style scoped>
.offers-outer {
  display: flex;
  flex-direction: column;
}
</style>
